module.exports = __webpack_public_path__ + "static/img/CHAIMANS-Letter.6184713.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/medias/images/whoweare/CHAIMANS-Letter.jpg
// module id = BRc9
// module chunks = 1